import { styled } from 'linaria/react';
import { css } from 'linaria';

export const ContainerButtons = styled.div`
  display: flex;
  gap: var(--space-200);

  @media (--only-mobile) {
    gap: var(--space-50);
  }
`;

export const goToCartButtonClass = css`
  padding: var(--space-150) var(--space-300);

  @media (--only-mobile) {
    padding: var(--space-100) var(--space-150);
  }
`;

export const NoticeContainer = styled.div<{ showTooltip?: boolean }>`
  display: ${props => (props.showTooltip ? 'flex' : 'none')};
  align-items: center;
  gap: var(--space-100);
  padding: var(--space-100);
  margin: var(--space-300);
  border-radius: var(--space-50);

  @media (--only-mobile) {
    align-items: flex-start;
    order: 3;
    width: 100%;
    padding: 0;
    margin: var(--space-100) 0 0;
  }
`;
